import {
  CartLinesUpdateEvent,
  CartErrorEvent
} from '@shopify/events';


class PackProduct extends HTMLElement {

  connectedCallback() {

    this.colourButtons =
      this.querySelectorAll(
        '.pack-product__colour'
      );

    this.combinations =
      this.querySelectorAll(
        '.pack-product__combination'
      );

    this.addButton =
      this.querySelector(
        '.pack-product__add-to-cart'
      );

    this.message =
      this.querySelector(
        '.pack-product__message'
      );

    this.priceContainer =
      this.querySelector(
        '[data-pack-price]'
      );

    this.originalPrice =
      this.querySelector(
        '.pack-product__original-price'
      );

    this.discountedPrice =
      this.querySelector(
        '.pack-product__discounted-price'
      );

    this.saving =
      this.querySelector(
        '.pack-product__saving'
      );

    this.unavailableMessage =
      this.querySelector(
        '.pack-product__unavailable'
      );

    this.colourName =
      this.querySelector(
        '.pack-product__colour-name'
      );


    /*
     * COLOUR / COMBINATION EVENTS
     */

    this.colourButtons.forEach(
      (button) => {

        button.addEventListener(
          'click',
          this.handleCombinationChange
        );

      }
    );


    /*
     * VARIANT / SIZE EVENTS
     */

    this.addEventListener(
      'change',
      this.handleVariantChange
    );


    /*
     * ADD TO CART
     */

    this.addButton?.addEventListener(
      'click',
      this.handleAddToCart
    );

    /*
 * URL HASH CHANGE
 */

window.addEventListener(
  'hashchange',
  this.handleHashChange
);
    


    /*
 * INITIAL STATE
 */

this.eshopInventoryReady = false;
this.updatePackState();

/*
 * LOAD E-SHOP INVENTORY (READ-ONLY)
 */

this.eshopInventoryReady = false;

this.loadEshopInventory().then(() => {

this.applyEshopInventory();

  this.eshopInventoryReady = true;

  this.updatePackState();

  console.log(
    '[pack-product] E-shop inventory ready'
  );
});


/*
 * INITIAL COLOUR
 *
 * The URL hash can select a pack combination.
 *
 * Example:
 *
 * /products/parure-de-lit#blanc-lisere-vanille
 */

const requestedCombination =
  window.location.hash
    .replace('#', '')
    .trim();


let initialColour = null;


/*
 * TRY TO FIND THE COLOUR
 * REQUESTED IN THE URL
 */

if (requestedCombination) {

  initialColour =
    Array.from(
      this.colourButtons
    ).find(
      (button) =>
        button.dataset.packCombination ===
        requestedCombination
    );

}


/*
 * IF THE URL DOES NOT CONTAIN A VALID
 * COMBINATION, USE THE DEFAULT ACTIVE ONE
 */

if (!initialColour) {

  initialColour =
    this.querySelector(
      '.pack-product__colour.is-active'
    );

}


/*
 * ACTIVATE THE INITIAL COLOUR
 *
 * We deliberately use click() here so that
 * all our existing behaviour runs:
 *
 * - active colour
 * - visible combination
 * - colour name
 * - price
 * - availability
 * - gallery images
 */

if (initialColour) {
  initialColour.click();
}

/*
 * MOVE PRODUCT DESCRIPTION BELOW PACK PRICE
 */

const moveDescription = () => {

  const descriptionBlock =
    document.querySelector(
      '[class*="product_description"]'
    );

  if (
    descriptionBlock &&
    this.priceContainer
  ) {
    this.priceContainer.after(
      descriptionBlock
    );

    return;
  }

  setTimeout(
    moveDescription,
    100
  );
};

moveDescription();

/*
 * MOVE SKEEPERS RATINGS BELOW PACK COLOUR NAME
 */

const moveRatings = () => {
  const ratings = document.querySelector(
    '.skeepers_product__stars:not(.skeepers_product__stars .skeepers_product__stars)'
  );

  if (!ratings || !this.colourName) {
    return false;
  }

  this.colourName.after(ratings);
  return true;
};

if (!moveRatings()) {
  const ratingsObserver = new MutationObserver(() => {
    if (moveRatings()) {
      ratingsObserver.disconnect();
    }
  });

  ratingsObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(() => {
    ratingsObserver.disconnect();
  }, 10000);
}


/*
 * MOVE EMBROIDERY ABOVE PACK ADD TO CART
 */

const moveEmbroidery = () => {

  const embroideryBlock =
    document.querySelector('.embroidery-block');

  if (
    embroideryBlock &&
    this.addButton
  ) {
    this.addButton.before(
      embroideryBlock
    );

    return;
  }

  setTimeout(
    moveEmbroidery,
    100
  );
};

moveEmbroidery();

}


  


  disconnectedCallback() {

    this.colourButtons?.forEach(
      (button) => {

        button.removeEventListener(
          'click',
          this.handleCombinationChange
        );

      }
    );


    this.removeEventListener(
      'change',
      this.handleVariantChange
    );


    this.addButton?.removeEventListener(
      'click',
      this.handleAddToCart
    );

    window.removeEventListener(
  'hashchange',
  this.handleHashChange
);
  }


  /*
   * ACTIVE COMBINATION
   */

  getActiveCombination() {

    return Array
      .from(this.combinations)
      .find(
        (combination) =>
          !combination.hidden
      );
  }


  /*
   * ACTIVE VARIANT SELECTORS
   */

  getActiveVariantSelectors() {

    const activeCombination =
      this.getActiveCombination();


    if (!activeCombination) {
      return [];
    }


    return Array.from(
      activeCombination.querySelectorAll(
        '.pack-product__variant'
      )
    );
  }


  getSelectedPackImage() {

  const activeButton =
    this.querySelector(
      '.pack-product__colour.is-active'
    );

  const combinationHandle =
    activeButton?.dataset.packCombination;

  if (!combinationHandle) {
    return this.dataset.productImage || '';
  }

  const images =
    this.getPackGalleryImages(
      combinationHandle
    );

  return (
    images[0]?.src ||
    this.dataset.productImage ||
    ''
  );
}

  /*
 * HASH CHANGE
 */

handleHashChange = () => {

  const requestedCombination =
    window.location.hash
      .replace('#', '')
      .trim();


  if (!requestedCombination) {
    return;
  }


  const colourButton =
    Array.from(
      this.colourButtons
    ).find(
      (button) =>
        button.dataset.packCombination ===
        requestedCombination
    );


  if (!colourButton) {
    return;
  }


  /*
   * DON'T CLICK AGAIN IF THIS
   * COLOUR IS ALREADY ACTIVE
   */

  if (
    colourButton.classList.contains(
      'is-active'
    )
  ) {
    return;
  }


  colourButton.click();

};


  /*
   * COLOUR CHANGE
   */

  handleCombinationChange = (event) => {

    const button =
      event.currentTarget;


    const selectedCombination =
  button.dataset.packCombination;


/*
 * UPDATE URL WITH SELECTED COLOUR
 *
 * replaceState keeps the current page
 * without causing a reload.
 */

if (selectedCombination) {

  const combinationHash = button.dataset.combinationHash;

  window.history.replaceState(
    null,
    '',
    `#${combinationHash}`
  );

}


/*
 * UPDATE PACK GALLERY
 */

this.updatePackGallery(
  selectedCombination
);


    /*
     * RESET ACTIVE COLOUR
     */

    this.colourButtons.forEach(
      (item) => {

        item.classList.remove(
          'is-active'
        );

      }
    );


    /*
     * SHOW SELECTED COMBINATION
     */

    this.combinations.forEach(
      (combination) => {

        combination.hidden =
          combination.dataset.combination !==
          selectedCombination;

      }
    );


    /*
     * ACTIVATE COLOUR BUTTON
     */

    button.classList.add(
      'is-active'
    );


    /*
     * UPDATE VISIBLE COLOUR NAME
     */

    if (this.colourName) {

      this.colourName.textContent =
        button.dataset.combinationName || '';

    }


    /*
 * APPLY PREFERRED SIZES
 */

this.applyPreferredSizes();


/*
 * RECALCULATE PRICE + AVAILABILITY
 */

this.updatePackState();

  };

    /*
   * PACK GALLERY IMAGES
   */

  getPackGalleryImages(combinationHandle) {

    const galleryData =
      document.querySelector(
        '[data-pack-gallery-media]'
      );


    if (!galleryData) {
      return [];
    }


    const combination =
      galleryData.querySelector(
        `[data-pack-gallery-combination="${CSS.escape(combinationHandle)}"]`
      );


    if (!combination) {
      return [];
    }


    return Array.from(
      combination.querySelectorAll(
        '.pack-gallery-media__item'
      )
    ).map(
      (item) => ({

        src:
          item.dataset.packGalleryImage,

        alt:
          item.dataset.packGalleryAlt || ''

      })
    );
  }


  /*
   * UPDATE PACK GALLERY
   */

    /*
   * UPDATE PACK GALLERY
   */

  updatePackGallery(combinationHandle) {

    const images =
      this.getPackGalleryImages(
        combinationHandle
      );


    if (!images.length) {
      return;
    }


    /*
     * FIND ATELIER MEDIA GALLERY
     */

    const mediaGallery =
      document.querySelector(
        'media-gallery'
      );


    if (!mediaGallery) {
      return;
    }


    /*
     * =========================================================
     * DESKTOP GRID
     * =========================================================
     *
     * Atelier renders a separate visible grid on desktop:
     *
     * ul.media-gallery__grid
     *   li.product-media-container
     *     div.product-media
     *       img.product-media__image
     */

    const grid =
      mediaGallery.querySelector(
        '.media-gallery__grid'
      );


    if (grid) {

      /*
       * REMOVE PREVIOUS PACK IMAGES
       */

      grid
        .querySelectorAll(
          '[data-pack-gallery-grid-item]'
        )
        .forEach(
          (item) => {

            item.remove();

          }
        );


      /*
       * ADD CURRENT COMBINATION IMAGES
       */

      images.forEach(
        (image, index) => {

          /*
           * GRID ITEM
           */

          const item =
            document.createElement(
              'li'
            );


          item.setAttribute(
            'ref',
            'media[]'
          );


          item.setAttribute(
            'data-pack-gallery-grid-item',
            ''
          );


          item.setAttribute(
            'data-pack-gallery-index',
            String(index)
          );


          item.className =
            'product-media-container media-fit-cover product-media-container--image product-media-container--force-aspect';


          item.style.setProperty(
            '--media-radius',
            '0px'
          );


          /*
           * MEDIA WRAPPER
           */

          const media =
            document.createElement(
              'div'
            );


          media.className =
            'product-media';


          /*
           * IMAGE
           */

          const img =
            document.createElement(
              'img'
            );


          img.src =
            image.src;


          img.alt =
            image.alt;


          img.loading =
            'lazy';


          img.className =
            'product-media__image';


          img.style.setProperty(
            '--focal-point',
            '50% 50%'
          );


          /*
           * BUILD GRID ITEM
           */

          media.appendChild(
            img
          );


          item.appendChild(
            media
          );


          const ghostItem =
  grid.querySelector(
    ':scope > li:not([data-pack-gallery-grid-item])'
  );


if (ghostItem) {

  grid.insertBefore(
    item,
    ghostItem
  );

} else {

  grid.appendChild(
    item
  );

}

        }
      );

    }


    /*
     * =========================================================
     * MOBILE / CAROUSEL SLIDESHOW
     * =========================================================
     *
     * Atelier also renders a separate slideshow.
     * It is hidden on your current desktop grid layout,
     * but we keep it updated for responsive behaviour.
     */

    const slidesContainer =
      mediaGallery.querySelector(
        'slideshow-slides[ref="scroller"]'
      );


    if (slidesContainer) {

      /*
       * REMOVE PREVIOUS PACK SLIDES
       */

      slidesContainer
        .querySelectorAll(
          '[data-pack-gallery-slide]'
        )
        .forEach(
          (slide) => {

            slide.remove();

          }
        );


      /*
       * ADD CURRENT COMBINATION SLIDES
       */

      images.forEach(
        (image, index) => {

          /*
           * SLIDE
           */

          const slide =
            document.createElement(
              'slideshow-slide'
            );


          slide.setAttribute(
            'ref',
            'slides[]'
          );


          slide.setAttribute(
  'aria-hidden',
  index === 0 ? 'false' : 'true'
);


          slide.setAttribute(
            'data-pack-gallery-slide',
            ''
          );


          slide.setAttribute(
            'data-pack-gallery-index',
            String(index)
          );


          slide.className =
            'product-media-container media-fit-cover product-media-container--image';


          /*
           * MEDIA WRAPPER
           */

          const media =
            document.createElement(
              'div'
            );


          media.className =
            'product-media';


          /*
           * IMAGE
           */

          const img =
            document.createElement(
              'img'
            );


          img.src =
            image.src;


          img.alt =
            image.alt;


          img.loading =
            'lazy';


          img.className =
            'product-media__image';


          img.style.setProperty(
            '--focal-point',
            '50% 50%'
          );


          /*
           * BUILD SLIDE
           */

          media.appendChild(
            img
          );


          slide.appendChild(
            media
          );

          const ghostSlide =
  slidesContainer.querySelector(
    ':scope > slideshow-slide:not([data-pack-gallery-slide])'
  );

slidesContainer.insertBefore(
  slide,
  ghostSlide
);




        }
      );

      slidesContainer
  .querySelectorAll(
    ':scope > slideshow-slide:not([data-pack-gallery-slide])'
  )
  .forEach(
    (slide) => slide.remove()
  );

    }

    const thumbnailsContainer =
  mediaGallery.querySelector(
    '.slideshow-controls__thumbnails'
  );

if (thumbnailsContainer) {
  thumbnailsContainer.innerHTML = '';

  images.forEach((image, index) => {
    const button = document.createElement('button');

    button.className =
      'slideshow-control button button-unstyled slideshow-controls__thumbnail';

    button.setAttribute(
      'aria-label',
      `Diapositive ${index + 1} sur ${images.length}`
    );

    button.setAttribute(
      'on:click',
      `/select/${index}`
    );

    button.setAttribute(
      'ref',
      'thumbnails[]'
    );

    button.addEventListener(
  'click',
  () => {
    slidesContainer.scrollTo({
      left: slidesContainer.clientWidth * index,
      behavior: 'smooth'
    });
  }
);

    button.style.setProperty(
      '--aspect-ratio',
      '1 / 1.25'
    );

    if (index === 0) {
      button.setAttribute(
        'aria-selected',
        'true'
      );
    }

    const img = document.createElement('img');

    img.src = image.src;
    img.alt = image.alt;
    img.loading = 'lazy';

    button.appendChild(img);
    thumbnailsContainer.appendChild(button);
  });
}




    /*
     * ALLOW ATELIER / BROWSER TO
     * RECALCULATE THE GALLERY LAYOUT
     */

    requestAnimationFrame(
      () => {

        window.dispatchEvent(
          new Event(
            'resize'
          )
        );

      }
    );

  }

  /*
 * E-SHOP INVENTORY
 *
 * Read-only inventory retrieval.
 * No availability changes at this stage.
 */

async loadEshopInventory() {

  const selects = this.querySelectorAll(
    '.pack-product__variant'
  );

  const products = new Map();

  selects.forEach((select) => {
    const { productId, productHandle } = select.dataset;

    if (productId && productHandle) {
      products.set(productId, productHandle);
    }
  });

  this.eshopInventory = new Map();

  await Promise.all(
    [...products].map(async ([productId, handle]) => {

      const url = new URL(
        'https://rest.locationinventory.info/v2/widget'
      );

      url.searchParams.set(
        'shop',
        'eurnxp-zt.myshopify.com'
      );

      url.searchParams.set('handle', handle);
      url.searchParams.set('id', productId);

      try {

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();

        if (!Array.isArray(data.variantLocations)) {
          throw new Error('Invalid inventory response');
        }

        data.variantLocations.forEach((variant) => {

          const location = variant.inventoryLocations?.find(
            (item) => Number(item.location?.id) === 123895349573
          );

          this.eshopInventory.set(
            String(variant.variant),
            location ? Number(location.quantity) : null
          );

        });

      } catch (error) {

        console.error(
          '[pack-product] E-shop inventory error:',
          handle,
          error
        );

      }

    })
  );

  console.log(
    '[pack-product] E-shop inventory loaded:',
    this.eshopInventory
  );

}

/*
 * CHECK E-SHOP VARIANT AVAILABILITY
 */

isEshopVariantAvailable(variantId) {

  if (!this.eshopInventory?.has(String(variantId))) {
    return false;
  }

  const quantity = this.eshopInventory.get(
    String(variantId)
  );

  return Number.isFinite(quantity) && quantity > 0;

}

/*
 * APPLY E-SHOP INVENTORY TO VARIANT OPTIONS
 */
applyEshopInventory() {

  this.querySelectorAll('.pack-product__variant')
    .forEach((select) => {

      Array.from(select.options).forEach((option) => {

        if (!this.isEshopVariantAvailable(option.value)) {
          option.disabled = true;
          option.dataset.available = 'false';
        }

      });

      const hasAvailableOption = Array.from(select.options)
        .some((option) => !option.disabled);

      if (!hasAvailableOption) {
  const placeholder = document.createElement('option');

  placeholder.value = '';
  placeholder.textContent = 'Indisponible';
  placeholder.disabled = true;
  placeholder.selected = true;
  placeholder.dataset.available = 'false';

  select.prepend(placeholder);
}

    });

}

  /*
 * DEFAULT PACK SIZES
 */

applyPreferredSizes() {

  const preferredSizes = [
    {
      names: [
        'housse de couette',
        'duvet cover'
      ],
      size: '240x220'
    },
    {
      names: [
        'drap housse',
        'fitted sheet'
      ],
      size: '160x200'
    },
    {
      names: [
        "taies d'oreiller",
        'taie d’oreiller',
        'pillowcase'
      ],
      size: '50x70'
    }
  ];

  const activeCombination =
    this.getActiveCombination();

  if (!activeCombination) {
    return;
  }

  activeCombination
    .querySelectorAll('.pack-product__item')
    .forEach((item) => {

      const title =
        item.querySelector(
          '.pack-product__item-title'
        )?.textContent
          .trim()
          .toLowerCase();

      const select =
        item.querySelector(
          '.pack-product__variant'
        );

      if (!title || !select) {
        return;
      }

      const preferred =
        preferredSizes.find(
          (entry) =>
            entry.names.some(
              (name) => title.includes(name)
            )
        );

      if (!preferred) {
        return;
      }

      const option =
        Array.from(select.options).find(
          (item) =>
            item.textContent.trim() ===
              preferred.size &&
            item.dataset.available === 'true' &&
            !item.disabled
        );

      if (option) {
        select.value = option.value;
      }

    });
}


  /*
   * SIZE / VARIANT CHANGE
   */

  handleVariantChange = (event) => {

    if (
      !event.target.matches(
        '.pack-product__variant'
      )
    ) {
      return;
    }


    this.updatePackState();
  };


  /*
   * CHECK COMPLETE PACK AVAILABILITY
   */

  isPackAvailable() {

    if (this.eshopInventoryReady === false) {
    return false;
  }

    const selectors =
      this.getActiveVariantSelectors();


    if (!selectors.length) {
      return false;
    }


    return selectors.every(
      (select) => {

        const option =
          select.options[
            select.selectedIndex
          ];


        if (!option) {
          return false;
        }


        return (
  option.dataset.available === 'true' &&
  !option.disabled &&
  Boolean(option.value) &&
  this.isEshopVariantAvailable(option.value)
);

      }
    );
  }


  /*
   * UPDATE PRICE + AVAILABILITY
   */

  updatePackState() {

    const selectors =
      this.getActiveVariantSelectors();


    const isAvailable =
      this.isPackAvailable();


    /*
     * PACK UNAVAILABLE
     */

    if (!isAvailable) {

      document.querySelector('.embroidery-block')?.setAttribute('hidden', '');
      document.querySelector('.expedition-date')?.setAttribute('hidden', '');

      if (this.priceContainer) {
        this.priceContainer.hidden = true;
      }


      if (this.unavailableMessage) {
        this.unavailableMessage.hidden = false;
      }


      if (this.addButton) {
        this.addButton.disabled = true;
      }


      return;
    }


    /*
     * PACK AVAILABLE
     */

    document.querySelector('.embroidery-block')?.removeAttribute('hidden');
    document.querySelector('.expedition-date')?.removeAttribute('hidden');

    if (this.priceContainer) {
      this.priceContainer.hidden = false;
    }


    if (this.unavailableMessage) {
      this.unavailableMessage.hidden = true;
    }


    if (this.addButton) {
      this.addButton.disabled = false;
    }


    /*
     * CALCULATE ORIGINAL TOTAL
     */

    const originalTotal =
      selectors.reduce(
        (total, select) => {

          const option =
            select.options[
              select.selectedIndex
            ];


          const price =
            Number(
              option?.dataset.price || 0
            );


          return total + price;

        },
        0
      );


    /*
     * DISCOUNT FROM PACK METAOBJECT
     */

    const discountPercentage =
      Number(
        this.dataset.discount || 0
      );


    const discountMultiplier =
      Math.max(
        0,
        1 - discountPercentage / 100
      );


    const discountedTotal =
      Math.round(
        originalTotal *
        discountMultiplier
      );


    /*
     * DISPLAY PRICE
     */

    if (this.originalPrice) {

      this.originalPrice.textContent =
        this.formatMoney(
          originalTotal
        );

    }


    if (this.discountedPrice) {

      this.discountedPrice.textContent =
        this.formatMoney(
          discountedTotal
        );

    }


    if (this.originalPrice) {

      this.originalPrice.hidden =
        discountPercentage <= 0;

    }


    if (this.saving) {

      this.saving.hidden =
        discountPercentage <= 0;

    }
  }

  /*
 * CURRENT PACK PRICE
 */

getSelectedPackPrice() {
  const selectors =
    this.getActiveVariantSelectors();

  if (!selectors.length) {
    return null;
  }

  const originalTotal =
    selectors.reduce(
      (total, select) => {
        const option =
          select.options[
            select.selectedIndex
          ];

        return (
          total +
          Number(
            option?.dataset.price || 0
          )
        );
      },
      0
    );

  const discountPercentage =
    Number(
      this.dataset.discount || 0
    );

  const discountMultiplier =
    Math.max(
      0,
      1 - discountPercentage / 100
    );

  return Math.round(
    originalTotal *
    discountMultiplier
  );
}


  /*
   * MONEY FORMATTING
   */

  formatMoney(cents) {

    const currency =
      this.dataset.currency ||
      'EUR';


    try {

      return new Intl.NumberFormat(
        document.documentElement.lang || 'fr-FR',
        {
          style: 'currency',
          currency
        }
      ).format(
        cents / 100
      );

    } catch (error) {

      return `${(
        cents / 100
      ).toFixed(2)} ${currency}`;

    }
  }


  /*
   * ADD COMPLETE PACK TO CART
   */

  handleAddToCart = async () => {

    if (!this.isPackAvailable()) {

      this.updatePackState();

      return;
    }


    const activeCombination =
      this.getActiveCombination();


    if (!activeCombination) {
      return;
    }


    const selectedVariants =
      this.getActiveVariantSelectors();


    if (!selectedVariants.length) {
      return;
    }


    /*
     * SELECTED COMBINATION NAME
     */

    const activeButton =
      this.querySelector(
        '.pack-product__colour.is-active'
      );


    const combinationName =
      activeButton?.dataset.combinationName ||
      activeButton?.textContent.trim() ||
      '';


    /*
     * UNIQUE PACK INSTANCE ID
     */

    const packId =
      typeof crypto !== 'undefined' &&
      crypto.randomUUID

        ? crypto.randomUUID()

        : `${Date.now()}-${Math.random()
            .toString(36)
            .slice(2)}`;


    const packName =
      this.dataset.packName || '';


    /*
     * BUILD REAL SHOPIFY CART ITEMS
     */

    const items =
      selectedVariants.map(
        (select) => ({

          id:
            Number(select.value),

          quantity:
            1,

          properties: {

            _PackID:
              packId,

            _Pack:
              packName,

            _PackURL:
              this.dataset.productUrl || '',

            _PackImage:
              this.getSelectedPackImage(),

            _Combinaison:
              combinationName

          }

        })
      );


    /*
     * DETERMINE WHICH ATELIER CART
     * SECTIONS NEED TO BE RETURNED
     */

    const cartItemsComponents =
      document.querySelectorAll(
        'cart-items-component'
      );


    const sectionIds = [];


    cartItemsComponents.forEach(
      (component) => {

        if (
          component instanceof HTMLElement &&
          component.dataset.sectionId
        ) {

          sectionIds.push(
            component.dataset.sectionId
          );

        }

      }
    );


    const uniqueSectionIds =
      [...new Set(sectionIds)];


    /*
     * CREATE ATELIER CART EVENT PROMISE
     */

    const deferredEventPromise =
      CartLinesUpdateEvent.createPromise();


    /*
     * TELL ATELIER ADD-TO-CART HAS STARTED
     */

    this.dispatchEvent(
      new CartLinesUpdateEvent({

        action:
          'add',

        context:
          'product',

        lines:
          items.map(
            (item) => ({

              merchandiseId:
                String(item.id),

              quantity:
                item.quantity

            })
          ),

        promise:
          deferredEventPromise.promise

      })
    );


    /*
     * LOADING STATE
     */

    this.addButton.disabled = true;

    this.addButton.setAttribute(
      'aria-busy',
      'true'
    );


    if (this.message) {
      this.message.hidden = true;
    }


    try {

      const response =
        await fetch(
          Theme.routes.cart_add_url,
          {

            method:
              'POST',

            headers: {

              'Content-Type':
                'application/json',

              Accept:
                'application/json'

            },

            credentials:
              'same-origin',

            body:
              JSON.stringify({

                items,

                sections:
                  uniqueSectionIds.join(','),

                sections_url:
                  window.location.pathname

              })

          }
        );


      const result =
        await response.json();


      /*
       * SHOPIFY ERROR
       */

      if (
        !response.ok ||
        result.status ||
        result.errors
      ) {

        const errorMessage =
          result.description ||
          result.message ||
          'Impossible d’ajouter la parure au panier.';


        deferredEventPromise.resolve({

          cart:
            null,

          detail: {
            didError: true
          }

        });


        this.dispatchEvent(
          new CartErrorEvent({

            error:
              errorMessage,

            code:
              'INVALID',

            detail: {

              description:
                result.description,

              errors:
                result.errors

            }

          })
        );


        throw new Error(
          errorMessage
        );
      }


      /*
       * GET COMPLETE UPDATED CART
       */

      const cartItemsComponent =
        document.querySelector(
          'cart-items-component'
        );


      let cart;


      if (cartItemsComponent) {

        await customElements.whenDefined(
          'cart-items-component'
        );


        cart =
          await cartItemsComponent
            .fetchCartData();

      } else {

        const cartResponse =
          await fetch(
            `${Theme.routes.cart_url}.json`,
            {

              headers: {
                Accept:
                  'application/json'
              },

              credentials:
                'same-origin'

            }
          );


        cart =
          await cartResponse.json();
      }


      /*
       * RESOLVE ATELIER CART EVENT
       */

      deferredEventPromise.resolve({

        cart:
          CartLinesUpdateEvent
            .createCartFromAjaxResponse(
              cart
            ),

        detail: {

          items:
            cart.items,

          source:
            'pack-product',

          sourceId:
            this.id,

          itemCount:
            items.length,

          productId:
            this.dataset.productId,

          sections:
            result.sections,

          didError:
            false

        }

      });


      /*
       * SUCCESS
       */

      if (this.message) {

        this.message.textContent =
          'Parure ajoutée au panier.';

        this.message.hidden =
          false;

      }


    } catch (error) {

      console.error(
        '[pack-product]',
        error
      );


      if (this.message) {

        this.message.textContent =
          error.message ||
          'Impossible d’ajouter la parure au panier.';

        this.message.hidden =
          false;

      }


    } finally {

      this.addButton.removeAttribute(
        'aria-busy'
      );


      this.updatePackState();

    }

  };

}


if (
  !customElements.get(
    'pack-product'
  )
) {

  customElements.define(
    'pack-product',
    PackProduct
  );

}